import { Reveal } from "./Reveal";

const contactItems = [
  {
    label: "E-mail",
    testid: "footer-email-link",
    href: "mailto:arthur@rentguru.nl",
    value: "arthur@rentguru.nl",
  },
  {
    label: "Telefoon",
    testid: "footer-phone-link",
    href: "tel:+31625172230",
    value: "06 2517 2230",
  },
];

export const Footer = () => {
  return (
    <footer
      id="contact"
      data-testid="footer-section"
      className="bg-foreground text-background"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-40">
        <Reveal>
          <p className="text-xs md:text-sm tracking-[0.3em] uppercase opacity-60 mb-8">
            Contact — we reageren binnen 24 uur
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-none">
            Neem contact op.
          </h2>
        </Reveal>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-12">
          {contactItems.map((item, i) => (
            <Reveal key={item.label} delay={0.15 + i * 0.08}>
              <p className="text-xs tracking-[0.25em] uppercase opacity-50 mb-3">
                {item.label}
              </p>
              <a
                data-testid={item.testid}
                href={item.href}
                className="font-display font-bold text-lg md:text-xl tracking-tight hover:opacity-70 transition-opacity duration-300"
              >
                {item.value}
              </a>
            </Reveal>
          ))}
          <Reveal delay={0.3}>
            <p className="text-xs tracking-[0.25em] uppercase opacity-50 mb-3">
              Adres kantoor
            </p>
            <p
              data-testid="footer-address"
              className="font-display font-bold text-lg md:text-xl tracking-tight leading-snug"
            >
              Anthony Fokkerweg 21
              <br />
              1059 CN Amsterdam
            </p>
          </Reveal>
        </div>

        <div className="mt-24 md:mt-40 grid grid-cols-2 md:grid-cols-4 gap-10 border-t border-background/20 pt-10">
          <div>
            <p className="font-display font-bold tracking-tight text-lg">
              RENT GURU
            </p>
            <p className="text-sm opacity-60 mt-2">
              Betaalbaar huren in Nederland.
            </p>
          </div>
          <div>
            <p className="text-xs tracking-[0.25em] uppercase opacity-50 mb-4">
              Website
            </p>
            <a
              data-testid="footer-site-link"
              href="https://rentguru.nl"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm hover:opacity-70 transition-opacity"
            >
              rentguru.nl
            </a>
          </div>
          <div>
            <p className="text-xs tracking-[0.25em] uppercase opacity-50 mb-4">
              Steden
            </p>
            <p className="text-sm opacity-80 leading-relaxed">
              Amsterdam · Rotterdam
              <br />
              Utrecht · Den Haag
              <br />
              Eindhoven · Groningen
            </p>
          </div>
          <div>
            <p className="text-xs tracking-[0.25em] uppercase opacity-50 mb-4">
              Juridisch
            </p>
            <p className="text-sm opacity-80 leading-relaxed">
              Privacyverklaring
              <br />
              Voorwaarden
            </p>
          </div>
        </div>

        <p className="mt-16 text-xs opacity-40">
          © 2026 Rent Guru — Alle rechten voorbehouden.
        </p>
      </div>
    </footer>
  );
};
